import _ from 'lodash';
import moment from 'moment-timezone';

export const TIME_FORMAT = 'hh:mm A';

/**
 * Generates an array of time strings in 15-minute intervals with a special 4:20 time option
 * @param now - Starting moment to generate times from
 * @returns Array of formatted time strings (e.g., ["12:00 PM", "12:15 PM", ...])
 */
export const getTimesWith420 = (now: moment.Moment): string[] =>
  _.reduce(
    _.range(0, 4 * 24),
    (acc: any[]) => {
      const time = now.add(15, 'minutes').format(TIME_FORMAT);
      acc.push(time);

      if (_.includes(time, '4:15')) {
        acc.push(now.add(5, 'minutes').format(TIME_FORMAT));
        now.add(-5, 'minutes');
      }
      return acc;
    },
    []
  );
